import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-description',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-description.component.html',
  styleUrl: './offer-description.component.css',
})
export class OfferDescriptionComponent {
  headerHighlight = input<string>();
  header = input<string>();
  descHeader = input<string>();
  descText1 = input<string>();
  descText2 = input<string>();
  logo1 = input<{ src: string; alt: string; link: string }>();
  logo2 = input<{ src: string; alt: string; link: string }>();
  logo3 = input<{ src: string; alt: string; link: string }>();
  logo4 = input<{ src: string; alt: string; link: string }>();
  logo5 = input<{ src: string; alt: string; link: string }>();
}
